import { GET_METHOD, POST_METHOD } from "../../axiosMethod";
import { getHeaders } from "../../config";


export const getNDAStatus = async (payload) => {
  try {
    const data = await GET_METHOD("nda/status", {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};

export const ndaAccept = async (payload) => {
  try {
    const data = await POST_METHOD("nda/accept",payload, {
      headers: getHeaders(),
    });
    return data;
  } catch (error) {
    return {
      data: error?.response?.data,
    };
  }
};
